// extracted by mini-css-extract-plugin
export default {"root":"NOfjpp","multiple":"AAiaHT","column":"NXZfSm","primary":"pA3W1n","secondary":"pBJkcV","responsive":"WWylcT"};